import * as uploadFileEvents from './uploadFileEvents';
import * as rfqEvents from './rfqEvents';
import * as chargeMixEvents from './chargeMixEvents';

export const ANALYTICS_EVENTS = {
  uploadFile: { ...uploadFileEvents },
  rfq: { ...rfqEvents },
  chargeMix: { ...chargeMixEvents }
};
